<template>
  <div>
    <div class="container-fluid">
      <div class="row justify-content-around align-items-center">
        <div class="col-md-8">
          <vx-card>
            <vs-row>
              <vs-col
                vs-type="flex"
                vs-justify="center"
                vs-align="center"
                vs-md="12"
                vs-lg="12"
                vs-sm="12"
              >
                <h3>{{ $t('updateCustomer') }}</h3>
              </vs-col>
            </vs-row>
            <vs-row class="mb-base">
              <vs-col
                vs-type="flex"
                vs-justify="flex-start"
                vs-align="flex-start"
                vs-md="6"
                vs-lg="6"
                vs-sm="6"
              >
                <vs-button icon="arrow_back" to="/customers">{{ $t('back') }}</vs-button>
              </vs-col>

              <vs-col
                vs-type="flex"
                vs-justify="flex-end"
                vs-align="flex-end"
                vs-md="6"
                vs-lg="6"
                vs-sm="6"
              >
                <vs-button
                  icon="save"
                  :disabled="!validateForm"
                  @click="updateCustomer"
                >{{ $t('save') }}</vs-button>
              </vs-col>
            </vs-row>
            <vs-row>
              <vs-col vs-justify="center" vs-align="center" vs-w="6">
                <vs-input
                  v-validate="'required'"
                  :name="$t('firstname')"
                  v-model="customer.FirstName"
                  class="w-full mt-6 mr-3"
                  :label-placeholder="$t('firstname')"
                />
                <span class="text-danger text-sm">{{ errors.first($t('firstname')) }}</span>
              </vs-col>
              <vs-col vs-justify="center" vs-align="center" vs-w="6">
                <vs-input
                  v-validate="'required'"
                  :name="$t('surname')"
                  :label-placeholder="$t('surname')"
                  v-model="customer.LastName"
                  class="w-full mt-6 ml-3"
                />
                <span class="text-danger text-sm">{{ errors.first($t('surname')) }}</span>
              </vs-col>
            </vs-row>
            <vs-row>
              <vs-col vs-justify="center" vs-align="center" vs-w="6">
                <vs-input
                  v-validate="'required'"
                  :name="$t('email')"
                  :label-placeholder="$t('email')"
                  v-model="customer.Email"
                  class="w-full mt-6 mr-3"
                  type="email"
                />
                <span class="text-danger text-sm">{{ errors.first($t('email')) }}</span>
              </vs-col>
              <vs-col vs-justify="center" vs-align="center" vs-w="6">
                <vs-input
                  v-validate="'required'"
                  :name="$t('address')"
                  :label-placeholder="$t('address')"
                  v-model="customer.Address"
                  class="w-full mt-6 ml-3"
                />
                <span class="text-danger text-sm">{{ errors.first($t('address')) }}</span>
              </vs-col>
            </vs-row>
            <vs-row>
              <vs-col vs-justify="center" vs-align="center" vs-w="6">
                <vs-input
                  v-validate="'required'"
                  :name="$t('phone')"
                  :label-placeholder="$t('phone')"
                  v-model="customer.Phone"
                  class="w-full mt-6 mr-3"
                  type="number"
                />
                <span class="text-danger text-sm">{{ errors.first($t('phone')) }}</span>
              </vs-col>
              <vs-col vs-justify="center" vs-align="center" vs-w="6">
                <vs-select
                  class="selectExample w-full mt-6 ml-3"
                  :placeholder="$t('status')"
                  autocomplete
                  v-model="customer.Active"
                >
                  <vs-select-item
                    :key="index"
                    :value="item.Active"
                    :text="item.name"
                    v-for="(item,index) in select"
                  />
                </vs-select>
              </vs-col>
            </vs-row>
            <vs-row>
              <vs-col vs-justify="center" vs-align="center" vs-w="6">
                <vs-input
                  v-validate="'required'"
                  :name="$t('userName')"
                  :label-placeholder="$t('userName')"
                  v-model="customer.UserName"
                  class="w-full mt-6 mr-3"
                />
                <span class="text-danger text-sm">{{ errors.first($t('userName')) }}</span>
              </vs-col>
              <vs-col vs-justify="center" vs-align="center" vs-w="6">
                <vs-input
                  :label-placeholder="$t('password')"
                  v-model="customer.UserPassword"
                  class="w-full mt-6 ml-3"
                />
              </vs-col>
            </vs-row>
          </vx-card>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
/* eslint-disable */
import http from "../../../http/http-helper";
import notify from "../../../shared/toast";

export default {
  computed: {
    validateForm() {
      return (
        !this.errors.any() &&
        this.customer.FirstName != "" &&
        this.customer.LastName != "" &&
        this.customer.Email != "" &&
        this.customer.Address != "" &&
        this.customer.Phone != "" &&
        this.customer.UserName != ""
      );
    }
  },
  data() {
    return {
      customer: {
        customerUserId: "",
        FirstName: "",
        LastName: "",
        Email: "",
        Address: "",
        Phone: "",
        Active: "",
        UserName: "",
        UserPassword: ""
      },
      select: [
        { name: this.$t("active"), Active: true },
        { name: this.$t("passive"), Active: false }
      ]
    };
  },
  methods: {
    // Update Customer
    updateCustomer() {
      let path = "/customers/update";
      http.post(path, this.customer).then(response => {
        notify.success(this.$t("updated"));
        this.$router.push("/customers");
      });
    },
    getData() {
      if (
        this.$route.params.id == null ||
        this.$route.params.firstName == null ||
        this.$route.params.lastName == null ||
        this.$route.params.email == null ||
        this.$route.params.address == null ||
        this.$route.params.phone == null ||
        this.$route.params.username == null
      )
        return this.$router.push("/customers");

      this.customer.customerUserId = this.$route.params.id;
      this.customer.FirstName = this.$route.params.firstName;
      this.customer.LastName = this.$route.params.lastName;
      this.customer.Email = this.$route.params.email;
      this.customer.Address = this.$route.params.address;
      this.customer.Phone = this.$route.params.phone;
      this.customer.UserName = this.$route.params.username;
      this.customer.Active = this.$route.params.active;
    }
  },
  created() {
    this.getData();
  }
};
</script>
<style scoped>
.colors {
  background-color: rgb(218, 216, 216) !important;
}
</style>